module.exports = __webpack_public_path__ + "img/2_m.29ac2c7c.jpg";